module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-actions"
  }, [(_vm.showSendDownStream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": !_vm.isSendDownStreamEnabled,
      "color": "primary",
      "label": "send downstream"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitToDC.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGenerateEstimate) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "primary",
      "label": _vm.activateLabel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.generateEstimate.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDuplicate) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "secondary",
      "label": "Duplicate"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.duplicate.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allowDownloadBtn) ? _c('action-button', {
    attrs: {
      "dark": "",
      "color": "secondary",
      "label": "download"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downloadTargetPackage.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotUndo,
      "color": "secondary",
      "dark": "",
      "label": "undo"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.undo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.canNotRedo,
      "color": "secondary",
      "dark": "",
      "label": "redo"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.redo.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": _vm.isClearAllDisabled,
      "color": "secondary",
      "dark": "",
      "label": "Clear All"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    staticStyle: {
      "min-width": "100px"
    },
    attrs: {
      "disabled": !_vm.isSaveEnabled,
      "color": "success",
      "label": _vm.saveLabel,
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7f434ce","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/definitionActions/DefinitionActions.vue
// module id = 2170
// module chunks = 0